import {
  composeValidators,
  duplicateValidator,
  textMaxLengthValidator,
  textValidator,
  urlValidator} from 'app/components/Form/utils/validators';

export const CREATELIST_FORM_RULES = {
  firstName: {
    validate: composeValidators(
      textValidator('PROCURE_2009'),
      textMaxLengthValidator('PROCURE_2009', 30),
    ),
  },
  lastName: {
    validate: composeValidators(
      textValidator('PROCURE_2010'),
      textMaxLengthValidator('PROCURE_2010', 30),
    ),
  },
  name: {
    validate: textValidator('PROCURE_27003'),  
  },
  wishlistName: {
    validate: textValidator('PROCURE_27003'),  
  },
  shippingAddress: {
    validate: textValidator('PROCURE_27005'),  
  },
  city: {
    validate: textValidator('PROCURE_2015'),  
  },
  state: {
    validate: textValidator('PROCURE_2014'),  
  },
  zipCode: {
    validate: textValidator('PROCURE_2012'),  
  },
  customUrl: (isDuplicate: boolean) =>{
    return {
      validate: composeValidators(
        textValidator('PROCURE_27004'),  
        urlValidator('PROCURE_27011'),
        duplicateValidator('PROCURE_27010', isDuplicate)
      ),
    }
  },
  eventDate: {
    validate: textValidator('PROCURE_27012'),  
  },
};
